import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Rate Card endpoints
  createRateCard: (data) => {
    return AxiosBusiness.post('rate-card', data)
  },

  updateRateCard: (rateCardId, data) => {
    return AxiosBusiness.put(`rate-card/${rateCardId}`, data)
  },

  deleteRateCard: (rateCardId) => {
    return AxiosBusiness.delete(`rate-card/${rateCardId}`)
  },

  getRateCard: (rateCardId) => {
    return AxiosBusiness.get(`rate-card/${rateCardId}`)
  },

  getAllRateCardsByTenant: (tenantId, params = {}) => {
    return AxiosBusiness.get(`rate-card/tenant/${tenantId}`, { params })
  },

  getAllRateCards: (params) => {
    return AxiosBusiness.get('rate-card', { params })
  }
}
